export default __webpack_public_path__ + "static/media/2017 DEC ZURY PASSION-01.1e59a9bf.jpg";